import classnames from 'classnames'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import 'styles/components/form-error-text.scss'

const FieldErrorText = ({ className, name, error }) => {
  if (isEmpty(error)) {
    return null
  }

  if (isEmpty(error.fieldErrors)) {
    return null
  }

  const messages = error.fieldErrors
    .filter(e => name === null || e.field === name)
    .map(e => <div key={e.uniqueKey}>{e.message}</div>)

  if (messages.length === 0) {
    return null
  }

  return <div className={classnames(className, 'form-error-text')}>{messages}</div>
}

FieldErrorText.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  error: PropTypes.instanceOf(Error)
}

FieldErrorText.defaultProps = {
  className: null,
  name: null,
  error: null
}

export default FieldErrorText
